import { try_on } from 'feature/widget/TryOnStore'
import { makeAutoObservable } from 'mobx'
import { employeeModal, EmployeeModalStore } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { employee } from 'page/catalog/employee/store/EmployeeStore'
import { demo } from 'page/catalog/store/CatalogStore'
import { user, UserStore } from 'page/catalog/store/UserStore'
import { userModal, UserModalStore } from 'page/catalog/UserModal/store/UserModalStore'
import { api } from 'store/api'
import { Client, ClientRequest, loadClient, saveClient } from 'type/client'
import { DemoCatalogData } from 'type/demo'
import { loadJson, saveJson } from 'util/storage'

export class BoutiqueController {
  private version = 1
  private _company_id: string = ''
  private data: DemoCatalogData | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get company_id(): string {
    return this._company_id
  }

  createClient(data: Client | null | undefined): UserStore | undefined {
    if (!data) return undefined

    const company = this.company_id
    if (!company) return undefined

    const manager_id = employee.manager_id
    if (!manager_id) return undefined

    return new UserStore(company, manager_id, data)
  }

  async startup(company_id: string, data: DemoCatalogData) {
    this._company_id = company_id
    this.data = data
    setInterval(() => {
      if (document.hidden) return
      const url = employee.auth ? location.href : undefined
      saveJson('boutique.url', url)
    }, 1000)
    await this.login()
    await this.importCustomer()
    if (!employee.user) {
      employeeModal.open(new EmployeeModalStore())
    }
  }

  async login() {
    const version = ++this.version

    employee.preload()
    const manager_id = employee.manager_id
    if (!manager_id) return

    let saved = loadClient(manager_id)
    if (saved && saved.company !== this.company_id) saved = undefined
    this.open(saved)

    await employee.load(this.company_id)
    if (version !== this.version) return
    if (!saved) return

    const be = demo.it.by_email
    const bc = demo.it.by_card
    const { company, phone, email, card } = saved

    let request: ClientRequest | undefined = undefined
    if (be) {
      if (email) request = { company, email }
    } else if (bc) {
      if (card) request = { company, card }
    } else {
      if (phone) request = { company, phone }
    }

    const data = request ? await api.findClient(request) : undefined
    if (version !== this.version) return
    this.open(data)
  }

  logout() {
    try_on.close()
    user.close()
    employee.logout()
  }

  private open(data: Client | undefined) {
    const manager_id = employee.manager_id
    const client = this.createClient(data)
    if (client) {
      user.open(client)
    } else {
      user.close()
      if (manager_id) saveClient(manager_id, undefined)
    }
  }

  private async importCustomer() {
    if (!this.data || !employee.user) return

    const user_id = loadJson<string>('boutique.import')
    if (!user_id) return

    const client = await api.getClient(user_id)
    if (!client) return

    this.open(client)
    saveJson('boutique.import', undefined)

    if (!client.name) {
      const store = new UserModalStore(this.data, client)
      store.step = 'edit'
      userModal.open(store)
    }
  }
}

export const boutique = new BoutiqueController()
